import { createRouter, createWebHistory } from 'vue-router';
import MainRoutes from './MainRoutes';
import AuthRoutes from './AuthRoutes';
import { useAuthStore } from '@/stores/auth';

export const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
        {
            path: '/:pathMatch(.*)*',
            component: () => import('@/views/authentication/Error.vue')
        },
        MainRoutes,
        AuthRoutes
    ]
});

router.beforeEach(async (to, from, next) => {
    const publicPages = ['/auth/login'];
    const isPublicPage = publicPages.includes(to.path);
    const auth: any = useAuthStore();

    // Si la ruta requiere autenticación y no hay usuario, redirigir al login
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        if (!auth.user) {
            auth.returnUrl = to.fullPath;
            return next({ path: '/auth/login', replace: true });
        }

        // Verificar roles si la ruta los requiere
        const requiredRoles = to.meta.roles as string[] | undefined;
        if (requiredRoles && requiredRoles.length > 0) {
            const userRoles: string[] = auth.user?.roles || [];
            const hasRole = requiredRoles.some((role: string) => userRoles.includes(role));
            if (!hasRole) {
                return next({ path: '/', replace: true });
            }
        }

        return next();
    }

    // Si el usuario ya está logueado y va al login, redirigir al home
    if (isPublicPage && auth.user) {
        return next({ path: '/', replace: true });
    }

    next();
});
